import { html, LitElement, PropertyValues } from 'lit';
import { property, state } from 'lit/decorators.js';
import { styles } from '../view/styles';

export class GzCounterWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/properties
  @property({
    type: Number,
    reflect: true,
  })
  target = 0;

  @property({
    type: Boolean,
    reflect: true,
  })
  animations = true;

  @state()
  private count = 0;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html` <span class="counter" part="counter-value">${this.count}</span> `;
  }

  updated(changedProperties: PropertyValues) {
    if (changedProperties.has('target')) {
      this.updateCount();
    }
  }

  private updateCount = () => {
    if (this.count < this.target) {
      /** If the counter is less than the target, increment the count by 1,
       * then run the updateCount function again, each 10ms.
       */
      this.count++;
      this.setAnimations(this.updateCount);
    } else if (this.count > this.target) {
      /** Run the function backwards to animate the number decrement */
      this.count--;
      this.setAnimations(this.updateCount);
    } else {
      this.count = this.target;
    }
  };

  private setAnimations(fn: () => void): void {
    if (this.animations) {
      setTimeout(fn, 10);
    } else {
      fn();
    }
  }
}
